<div id="tour-onboarding-header" class="flex align-items-center">
  <button
    id="tour-onboarding-back"
    pButton
    title="Go to records list"
    severity="secondary"
    icon="pi pi-arrow-left"
    size="large"
    class="ml-2"
    [rounded]="true"
    [raised]="true"
    [disabled]="isProcessingRevio"
    (click)="goToRecords()"></button>
  <h1 class="ml-2">Client onboarding</h1>
</div>
<p-stepper id="tour-stepper" [(activeStep)]="active">
  @for (step of steps; let index = $index; track $index) {
    <p-stepperPanel>
      <ng-template pTemplate="header" let-onClick="onClick">
        <button
          class="bg-transparent border-none inline-flex flex-column gap-2 align-items-center"
          [ngClass]="{ 'cursor-pointer': !step.disabled && !isProcessingRevio }"
          [disabled]="step.disabled || isProcessingRevio"
          (click)="onClick.emit()">
          <span
            class="border-round w-3rem h-3rem inline-flex align-items-center justify-content-center relative"
            [ngClass]="
              index === active
                ? 'bg-primary border-primary border-2'
                : {
                    'border-2 surface-border': step.disabled,
                    'step-valid': !step.disabled && step.valid && !(step.key === 'summary' && onBoardingRecord?.parentCustomerId && onBoardingRecord?.status !== 'FINISHED'),
                    'step-partial': !step.disabled && step.key === 'summary' && onBoardingRecord?.parentCustomerId && onBoardingRecord?.status !== 'FINISHED',
                    'step-invalid': !step.disabled && !step.valid && !(step.key === 'summary' && onBoardingRecord?.parentCustomerId)
                  }
            ">
            <i [class]="step.icon" [title]="step.title"></i>
            @if (step.key === 'summary' && onBoardingRecord?.parentCustomerId && onBoardingRecord?.status !== 'FINISHED') {
              <span class="step-sent-badge" title="Customers & sites sent to Rev.io">
                <i class="pi pi-check"></i>
              </span>
            }
          </span>
          <div class="flex flex-column align-items-center gap-1">
            <span class="text-sm font-medium text-center" [ngClass]="{
              'text-primary': index === active,
              'text-600': index !== active && !step.disabled,
              'text-400': step.disabled
            }">{{ step.title }}</span>
            <span class="text-xs text-center" [ngClass]="{
              'text-primary': index === active,
              'text-500': index !== active && !step.disabled,
              'text-400': step.disabled
            }" *ngIf="step.description">{{ step.description }}</span>
          </div>
        </button>
      </ng-template>
      <ng-template
        pTemplate="content"
        let-prevCallback="prevCallback"
        let-nextCallback="nextCallback">
        @switch (step.key) {
          @case ('customer') {
            <app-client-onboarding-customer
              *ngIf="customer"
              [onBoardingId]="onBoardingRecord?.id"
              [domain]="onBoardingRecord?.domain"
              [customer]="customer"
              (customerSaved)="customerSavedHandler($event,step,nextCallback)">
            </app-client-onboarding-customer>
          }
          @case ('locations') {
            <app-client-onboarding-locations
              [onBoardingId]="onBoardingRecord?.id"
              [domain]="onBoardingRecord?.domain"
              [locations]="locations"
              (locationsReady)="navigationHandler($event,prevCallback,nextCallback)">
            </app-client-onboarding-locations>
          }
          @case ('services') {
            <app-client-onboarding-services
              [onBoardingId]="onBoardingRecord?.id"
              [domain]="onBoardingRecord?.domain"
              [locations]="locations"
              [parentCustomerId]="parentCustomerId"
              (servicesReady)="navigationHandler($event,prevCallback,nextCallback)">
            </app-client-onboarding-services>
          }
          @case ('items') {
            <app-client-onboarding-products-list
              [onBoardingId]="onBoardingRecord?.id"
              [domain]="onBoardingRecord?.domain"
              [items]="onBoardingRecord?.products"
              (productsReady)="navigationHandler($event,prevCallback,nextCallback)"></app-client-onboarding-products-list>
          }
          @case ('summary') {
            <app-client-onboarding-summary
              [onBoardingRecord]="onBoardingRecord"
              (summaryReady)="navigationHandler($event,prevCallback,nextCallback)"
              (processingStateChange)="onProcessingStateChange($event)">
            </app-client-onboarding-summary>
          }
        }
      </ng-template>
    </p-stepperPanel>
  }
</p-stepper>
